export default function SearchIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0252 12.8488L17.5943 16.4171L16.4152 17.5963L12.8469 14.0271C11.5191 15.0915 9.86768 15.6704 8.16602 15.668C4.02602 15.668 0.666016 12.308 0.666016 8.16797C0.666016 4.02797 4.02602 0.667969 8.16602 0.667969C12.306 0.667969 15.666 4.02797 15.666 8.16797C15.6684 9.86964 15.0895 11.5211 14.0252 12.8488ZM12.3535 12.2305C13.4111 11.1429 14.0017 9.68499 13.9993 8.16797C13.9993 4.94464 11.3885 2.33464 8.16602 2.33464C4.94268 2.33464 2.33268 4.94464 2.33268 8.16797C2.33268 11.3905 4.94268 14.0013 8.16602 14.0013C9.68304 14.0037 11.1409 13.4131 12.2285 12.3555L12.3535 12.2305Z"
        fill="#111615"
      />
    </svg>
  );
}
